// Copyright (c) 2018 ml5
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

/*
Word2Vec
*/

const word2vec = () => {
  console.log('%cword2vec has been disabled', 'color: #A155FF; font-size: 16px');
  console.log(
    `We've intentionally disabled the word2vec function after recognizing it has the ` +
    `potential to produce harmful outputs while using the model files included in our ` +
    `examples. We'll consider reenabling the word2vec function along with changes to ` +
    `address these issues in a future release of ml5.js. You can find further updates ` +
    `about this topic on our Twitter account (https://twitter.com/ml5js/status/1445762321444315147) and GitHub ` +
    `(https://github.com/ml5js/ml5-library/issues/1238).`,
  );
};

export default word2vec;
